import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Button, Dialog } from "@justworkshr/milo-components";
import FooterButton from "uicomponents/FooterButton";
import EditCard from "uicomponents/EditCard";
import Alert from "uicomponents/Alert";
import { CANCEL_BUTTON_TEXT } from "pages/WorkersCompApplcation/utils/contants";
import isEqual from "lodash/isEqual";
import styles from "./EditCard.module.css";

interface IEditFormProps {
  initialFormValues: any;
  validationSchema: any;
  handleOnSubmit: any;
  validateInlineErrors?: any;
  title: any;
  description?: any;
  isError: any;
  errorMessage: any;
  nextButtonText: any;
  disabled: any;
  children: any;
  handleBackClick: any;
  hasOnlyBackButton?: boolean;
  hasOnlyNextButton?: boolean;
  isMergeDialogOpen?: any;
  setIsMergeDialogOpen?: any;
  dialogFotterButtonSubmit?: any;
  focusField?: any;
}

const EditForm = ({
  initialFormValues,
  validationSchema,
  handleOnSubmit,
  validateInlineErrors,
  title,
  description,
  isError,
  errorMessage,
  nextButtonText,
  disabled,
  children,
  handleBackClick,
  hasOnlyBackButton,
  hasOnlyNextButton,
  isMergeDialogOpen,
  setIsMergeDialogOpen,
  dialogFotterButtonSubmit,
  focusField,
}: IEditFormProps): JSX.Element => {
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);

  const handleButtonBackClick = (values: any) => {
    if (isEqual(initialFormValues, values)) {
      handleBackClick();
    } else {
      setIsCancelDialogOpen(true);
    }
  };

  const closeModalAndStopEditing = () => {
    setIsCancelDialogOpen(false);
    handleBackClick();
  };

  return (
    <>
      <Formik
        initialValues={initialFormValues}
        validationSchema={validationSchema}
        onSubmit={handleOnSubmit}
        validate={validateInlineErrors}
      >
        {({ errors, handleSubmit, values }) => (
          <>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                let firstErrorFieldName = Object.keys(errors)[0];
                focusField(firstErrorFieldName);
                handleSubmit(e);
              }}
            >
              <EditCard
                title={title}
                showEditIcon={false}
                description={description}
              >
                {children}
                <FooterButton
                  nextButtonText={nextButtonText || "Done"}
                  handleBackClick={() => handleButtonBackClick(values)}
                  backButtonText={CANCEL_BUTTON_TEXT}
                  disabled={disabled}
                  hasOnlyBackButton={hasOnlyBackButton}
                  hasOnlyNextButton={hasOnlyNextButton}
                />
                {isError && (
                  <Alert message={errorMessage} allowAutoScroll={false} />
                )}
              </EditCard>
            </Form>
            {isMergeDialogOpen && (
              <Dialog
                isOpen={isMergeDialogOpen}
                onClose={() => setIsMergeDialogOpen(false)}
                data-testid="merge-dialog"
                title="Checking on a duplicate person"
                primaryButton={
                  <Button
                    onClick={() => {
                      setIsMergeDialogOpen(false);
                      dialogFotterButtonSubmit(values, true);
                    }}
                    variant="filled"
                  >
                    Same Person
                  </Button>
                }
                secondaryButton={
                  <Button
                    onClick={() => {
                      setIsMergeDialogOpen(false);
                      dialogFotterButtonSubmit(values);
                    }}
                    variant="ghost"
                  >
                    Different People
                  </Button>
                }
              >
                <p className={styles.modalDescription}>
                  <b>
                    {values.firstName} {values.lastName}
                  </b>{" "}
                  was added as an owner and employee. Are there two different{" "}
                  {values.firstName} {values.lastName}'s or is it the same
                  person?
                </p>
              </Dialog>
            )}
          </>
        )}
      </Formik>
      <Dialog
        isOpen={isCancelDialogOpen}
        onClose={() => setIsCancelDialogOpen(false)}
        title="Leave this page?"
        primaryButton={
          <Button onClick={() => setIsCancelDialogOpen(false)} variant="filled">
            Add more info
          </Button>
        }
        secondaryButton={
          <Button onClick={closeModalAndStopEditing} variant="ghost">
            Don’t save
          </Button>
        }
      >
        <p>
          Any partial info you’ve entered won’t be saved. Do you want to go back
          and add the rest of the info?
        </p>
      </Dialog>
    </>
  );
};

export default EditForm;
